var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoundsecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.845 2.04728L6.30707 6.72913C5.22317 7.21086 4.51562 8.29476 4.51562 9.48404V16.5595C4.51562 24.9146 10.2964 32.7277 18.0644 34.6245C25.8323 32.7277 31.6131 24.9146 31.6131 16.5595V9.48404C31.6131 8.29476 30.9056 7.21086 29.8217 6.72913L19.2838 2.04728C18.516 1.70104 17.6127 1.70104 16.845 2.04728ZM18.0644 18.0499H28.6023C27.8044 24.2522 23.6645 29.7771 18.0644 31.5083V18.0649H7.52646V9.48404L18.0644 4.80219V18.0499Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundsecurity);
export default __webpack_public_path__ + "static/media/roundsecurity.c280132ebf3653ea2e32180d73f4f7e5.svg";
export { ForwardRef as ReactComponent };